import { send } from 'server';

export const sendRealityCheckNotification = (actionId, action) => send({
    ID: 89917,
    description: 'send Reality Check Notification',
    responses: [89918, 89900],
    action,
    actionId
});
